// TODO: This will be refactored back to the NPM open source module and be part of the pict-section-entitymanagement this weekend
// TODO: For now treat this as a slightly enhanced stub

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const libPictProvider = require('pict-provider');

class SessionProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.options;

		/** @type {any} */
		this._Session = null;

		this.sessionChangeCallbacks = [];
	}

	onSessionChange(fCallback)
	{
		if (typeof fCallback === 'function')
		{
			this.sessionChangeCallbacks.push(fCallback);
		}
	}

	onInitializeAsync(fCallback)
	{
		// check for initial logged in state
		this.syncLoggedInState().catch((error) =>
		{
			this.pict.log.error(`Error syncing logged in state: ${error.message || error}`);
		}).finally(fCallback);
	}

	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (error, payload) =>
			{
				if (error)
				{
					return reject(error);
				}
				resolve(payload);
			});
		});
	}

	async _triggerSessionChange(pOldSession, pNewSession)
	{
		for (const callback of this.sessionChangeCallbacks)
		{
			try
			{
				await callback(pNewSession, pOldSession);
			}
			catch (error)
			{
				this.pict.log.error(`Error in session change callback: ${error.message || error}`, { stack: error.stack });
			}
		}
	}

	/**
	 * Shape of the session object stored in memcache, and returned from CheckSession.
	 * @typedef {Object} SessionInfo
	 * @property {string} SessionID - The session ID.
	 * @property {boolean} LoggedIn - True if the user is logged in.
	 * @property {string} UserRole - The human readable role of the user.
	 * @property {number} UserRoleIndex - The user's (0-5) level.
	 * @property {number} UserID - The IDUser (database ID) of the user.
	 * @property {number} CustomerID - The IDCustomer (database ID) of the customer.
	 * @property {boolean} [Impersonation] - True when this session is impersonating another user.
	 * @property {string} Title - The title of the user.
	 * @property {string} NameFirst - The first name of the user.
	 * @property {string} NameLast - The last name of the user.
	 * @property {string} Email - The email of the user.
	 * @property {string} LoginID - The login ID of the user.
	 * @property {string} UIHash - The UI hash of the user. (not sure what this is for)
	 * @property {string} Timezone - The timezone of the user.
	 * @property {Record<string, any>} Settings - The user's settings.
	 * @property {string} LastSessionID - The user's last session ID.
	 * @property {string} LastLoginTime - The time of the user's last login.
	 * @property {Array<string>} UserRoles - The roles of the user.
	 * @property {string} DeviceID - The device ID associated with the session.
	 * @property {number} IDDevice - The IDDevice (database ID) of the device record associated with the session.
	 */

	/**
	 * @return {Promise<SessionInfo | null>}
	 */
	async syncLoggedInState()
	{
		const session = await this._get(`CheckSession`);
		if (!session || !session.LoggedIn)
		{
			if (this._Session && this._Session.LoggedIn)
			{
				await this._triggerSessionChange(this._Session, null);
			}
			this._Session = null;
			this._Permissions = null;
			return this._Session;
		}
		if (!this._Session || this._Session.UserID != session.UserID)
		{
			await this._triggerSessionChange(this._Session, session);

			// some kind of event that user changed?
			this._Permissions = null;
		}
		this._Session = session;
		// Customer permissions load lazily through getPermissions(); nothing needs them at boot.
		return this._Session;
	}

	/**
	 * @return {boolean} whether a logged-in session is cached from a previous sync.
	 */
	hasSession()
	{
		return !!(this._Session && this._Session.LoggedIn);
	}

	/**
	 * Drop the cached session so the next getSession()/syncLoggedInState() asks the server again.
	 */
	invalidateSession()
	{
		this._Session = null;
		this._Permissions = null;
	}

	async getPermissions()
	{
		if (!this._Permissions)
		{
			//FIXME: project aware permissions
			this._Permissions = await this._get(`Permissions/For/User/In/Customer/${this._Session.CustomerID}`);
		}
		return this._Permissions;
	}

	async getSession()
	{
		if (!this._Session)
		{
			this._Session = await this._get(`CheckSession`);
		}
		return this._Session;
	}
}

module.exports = SessionProvider;

module.exports.default_configuration = (
	{
		ProviderIdentifier: 'SessionProvider',
	});
